import React, { useEffect, useRef, useState } from "react";
import v1 from "../assest/vid.webm";
import NET from "vanta/dist/vanta.net.min";
import * as THREE from "three";
import 'bootstrap/dist/css/bootstrap.min.css';
import './Hero.css';

function Hero() {
  const heroRef = useRef(null);
  const vantaEffect = useRef(null);

  const headlines = [
    "WEBSITE DESIGNING",
    "FACEBOOK MARKETING",
    "ANDROID APPLICATION DEVELOPMENT",
    "CUSTOMIZED ERP'S",
    "E-COMMERCE PORTAL",
    "KOHA LMS INSTALLATION",
  ];

  const [currentHeadline, setCurrentHeadline] = useState(0);
  const [fade, setFade] = useState(true); // true = visible

  useEffect(() => {
    const interval = setInterval(() => {
      // Fade out
      setFade(false);
      setTimeout(() => {
        // Change headline and fade in
        setCurrentHeadline(prev => (prev + 1) % headlines.length);
        setFade(true);
      }, 300); // 300ms fade out
    }, 2000); // Change every 1s
    return () => clearInterval(interval);
  }, []);

  // Vanta initialization
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!vantaEffect.current && heroRef.current) {
        vantaEffect.current = NET({
          el: heroRef.current,
          THREE: THREE,
          mouseControls: true,
          touchControls: true,
          color: 0xffffff,
          backgroundColor: 0x000000,
          points: 15,
          maxDistance: 20,
          spacing: 20
        });
      }
    }, 50);
    return () => {
      clearTimeout(timer);
      if (vantaEffect.current) vantaEffect.current.destroy();
    };
  }, []);

  return (
    <div
      ref={heroRef}
      style={{ width: "100%", height: "100vh", position: "relative", overflow: "hidden" }}
    >
      <div style={{ position: "relative", width: "100%", height: "100%", zIndex: 2 }}>
        <div className="container h-100">
          <div className="row h-100 align-items-center">
            {/* Left column */}
            <div className="col-md-6 text-center text-md-start">
              <p style={{
                color: "#00ffea",
                fontSize: "1.5rem",
                letterSpacing: "2px",
                textTransform: "uppercase",
                marginBottom: "10px"
              }}>
                Craft Beyond Ordinary
              </p>
              <h1 className={`fade-text ${fade ? "visible" : "hidden"}`} style={{
                color: "#ffffff",
                fontSize: "3rem",
                fontWeight: "700",
                height: "100px",
                marginBottom: "20px",
              }}>
                {headlines[currentHeadline]}
              </h1>
              <button className="btn-work btn btn-success btn-lg">View Our Work</button>
              <button className="btn btn-success btn-lg">Get In Touch</button>
            </div>

            {/* Right column */}
            <div className="col-md-6 d-flex justify-content-center">
              <video 
                src={v1} 
                autoPlay 
                loop 
                muted 
                style={{
                  maxWidth: "100%",
                  borderRadius: "20px",
                  boxShadow: "0 0 20px rgba(0,255,234,0.5)"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
